/**
 * The "next photo" placeholder tile shown at the end of the grid while photos are still coming in
 * (SelectPhotosPanel, reception state). It is a pure display cell : a dashed square with a spinner.
 *
 * NextPhotoPlaceholder is a distinct (empty) class so VerticalGridDynamic maps it to this renderer
 * by constructor name. It is appended only to the grid's DISPLAY data (ReceivingGrid.data getter),
 * never to the received photos, so the import / count / discard are untouched.
 */
fx.ns("shared.models", class NextPhotoPlaceholder {

	// the grid keys its rows and renderers on the id, so each waiting cell needs its own
	constructor(i)
	{
		this.id = "next-" + i;
	}
});

fx.ns("shared.renderers", class NextPhotoRenderer extends fx.Component {

	create()
	{
		super.create();

		// an inset dashed cell (same 7px inset as the photo tiles) ; the spinner is drawn in CSS
		this.addChild(new fx.components.Box("next-cell"), { top : 7, left : 7, right : 7, bottom : 7 });
	}
});
